export type QueryParamStrategy = {
    provideParams: () => Partial<Record<string, string>>;
};

export const defaultServerQueryParamStrategy: Partial<QueryParamStrategy> = {};

export const memoryCacheQueryParamStrategy: Partial<QueryParamStrategy> = {};
